/* @flow weak */
import { apiPost } from '../lib/api'

export const APP_SET_LOCATION = 'APP_SET_LOCATION'
export const APP_START = 'APP_START'
export const APP_STORAGE_LOAD = 'APP_STORAGE_LOAD'
export const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE'
export const SHOW_ERROR = 'SHOW_ERROR'
export const LOG_BUG = 'LOG_BUG'
export const SET_CHANGED_ROUTE = 'SET_CHANGED_ROUTE'
export const SET_AFTER_AUTH_REDIRECT = 'SET_AFTER_AUTH_REDIRECT'
export const SET_FIRST_URL = 'SET_FIRST_URL'

export const SET_COUNTRY_CODE_START = 'SET_COUNTRY_CODE_START'
export const SET_COUNTRY_CODE_SUCCESS = 'SET_COUNTRY_CODE_SUCCESS'
export const SET_COUNTRY_CODE_ERROR = 'SET_COUNTRY_CODE_ERROR'


export const setLocation = (location) => ({
  type: APP_SET_LOCATION,
  payload: { location },
})

export const start = () => {
  const loadStorage = async (dispatch, storageEngine) => {
    const state = await storageEngine.load()
    dispatch({ type: APP_STORAGE_LOAD, payload: state })
  }
  return ({ dispatch, storageEngine }) => {
    loadStorage(dispatch, storageEngine).finally(() => {})
    return {
      type: APP_START,
    }
  }
}

export const setAfterAuthRedirect = (url) => ({
  type: SET_AFTER_AUTH_REDIRECT,
  payload: url,
})

export const setFirstUrl = (url) => ({
  type: SET_FIRST_URL,
  payload: url,
})

export const clearFlashMessage = () => ({
  type: CLEAR_FLASH_MESSAGE,
})

export const setChangedRoute = () => ({
  type: SET_CHANGED_ROUTE,
})

export const showError = (text) => ({
  type: SHOW_ERROR,
  payload: text,
})

export const logError = (body) => ({ getState, fetch }) => ({
  type: LOG_BUG,
  payload: apiPost({
    fetch,
    endpoint: 'log/error',
    getState,
    body,
  }),
})

// http://ip-api.com/json/
export const setCountryCode = () => ({
  type: 'SET_COUNTRY_CODE',
  payload: fetch(`https://geoip-db.com/json/`).then(data => {
    return data.json()
  }),
})


// WEBPACK FOOTER //
// ./src/common/app/actions.js